import React, { forwardRef } from 'react'

const SelectedItems = forwardRef(({ selectedValue, handleSelected }, ref) => (
  <div ref={ref} className="selected-items-group">
    {
      selectedValue.map((item, index) => {
        return <span
          className='selected-item'
          key={index}>
          {item.name}
          <span onClick={() => handleSelected(item.idIndex, index)}>x</span>
        </span>
      })
    }
  </div>
));

export default SelectedItems;